// NodeShareModal.jsx

import React from 'react';

// Device Detection
import { useIsMobile } from 'hooks/useDeviceDetect';

// CSS
import './NodeShareModal.css';

// Components
import NodeShare from './NodeShare';
import Modal from 'components/modal/Modal';

/**
 * NodeShareModal
 *
 * Displays a modal dialog (desktop) or sheet (mobile) for a node's QR code.
 *
 * @param {object} node - The node object whose QR code is shown.
 * @param {boolean} isOpen - Whether the modal is currently open.
 * @param {Function} setOpen - Function to set the open state of the modal.
 *
 * @returns {ReactNode} - NodeShareModal
 */
const NodeShareModal = ({ node, isOpen, setOpen }) => {

    // ----- DEVICE DETECTION ----- //

    const isMobile = useIsMobile();
    if (!isOpen || !node) return null;

    // ----- RENDER ----- //

    return (

        <Modal
          title="QR Code"
          isOpen={isOpen}
          width={isMobile ? "100%" : "auto"}
          height="auto"
          onClose={() => setOpen(false)}
        >

            <NodeShare
                node={node}
            />

        </Modal>
    );
};

// Dev Tools
NodeShareModal.displayName = 'NodeShareModal';

export default NodeShareModal;
